import VideoSpeeder from '../views/videoSpeeder.vue';
import VideoSpeederPanel from '../components/rightPanel/videoSpeederPanel.vue';
export default {
  path: '/videoSpeeder',
  name: 'VideoSpeeder',
  components: {
    default: VideoSpeeder,
    panel: VideoSpeederPanel
  }
};
